export enum STATUS {
  complete = 'complete',
  error = 'error',
  idle = 'idle',
  loading = 'loading',
}
